import React, { PropsWithChildren } from 'react';

import Xmark from '@gravity-ui/icons/Xmark';
import { Button, Icon, Modal } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/DraftControlPanel';

import styles from './ModalWithConfirmation.module.scss';

const t = i18n(keyset);

export const ModalWithConfirmation = (
    props: PropsWithChildren<{
        title: string;
        text?: React.ReactNode;
        confirmButtonLabel: string;
        cancelButtonLabel?: string;
        onConfirm: () => void;
        onClose: () => void;
        loading?: boolean;
        confirmDisabled?: boolean;
        displayClose?: boolean;
        displayCancelButton?: boolean;
    }>,
) => {
    const {
        children,
        confirmButtonLabel,
        cancelButtonLabel,
        confirmDisabled,
        onClose,
        onConfirm,
        text,
        title,
        loading,
        displayClose = true,
        displayCancelButton = true,
    } = props;
    return (
        <Modal open onClose={onClose}>
            <div className={styles.modal__container}>
                <header className={styles.modal__header}>
                    <span className={styles.modal__title}>{title}</span>
                    {displayClose && (
                        <Button className={styles.modal__closeButton} onClick={onClose} size="l" view="flat">
                            <Icon data={Xmark} />
                        </Button>
                    )}
                </header>
                <div className={styles.modal__content}>{text}</div>
                <div className={styles.modal__content}>{children}</div>
                <footer className={styles.modal__footer}>
                    <Button onClick={onConfirm} size="l" view="action" loading={loading} disabled={confirmDisabled}>
                        {confirmButtonLabel}
                    </Button>
                    {displayCancelButton && (
                        <Button onClick={onClose} size="l">
                            {cancelButtonLabel ?? t('cancel')}
                        </Button>
                    )}
                </footer>
            </div>
        </Modal>
    );
};
